import React from 'react';
import { ChevronRight, Briefcase, Star, Heart, ExternalLink } from 'lucide-react';
import { useAppContext } from '../../../core/App'; // NEW

// --- JobMatchesDisplay Component (Gemini Enhanced) ---
export default function JobMatchesDisplay({ matches }) {
  const { toggleSavedJob, userProfile } = useAppContext(); // NEW

  if (!matches || matches.length === 0) return null;

  // NEW: Helper to check saved status
  const isJobSaved = (job) => {
      return userProfile?.savedJobs?.some(j => j.title === job.title); 
      // Note: In a real app we'd use a unique job ID, but title is fine for this simulated list
  };

  return (
    <div className="mt-8 text-left animate-fade-in">
      <h4 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
        <Briefcase className="w-6 h-6 mr-2 text-blue-600" />
        Best-Fit Career Paths For You
      </h4>
      <div className="space-y-3">
        {matches.map((job, index) => {
          const saved = isJobSaved(job);
          
          return (
            <div 
                key={index} 
                className="block p-4 bg-white border border-gray-200 rounded-lg shadow-sm transition-all duration-200 hover:shadow-md hover:border-blue-300 relative overflow-hidden group"
            >
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                      <h5 className="font-bold text-lg text-blue-700">
                        {job.title}
                      </h5>
                      {job.relevance === 'High' && (
                        <span className="px-2 py-0.5 bg-green-100 text-green-800 text-xs rounded-full flex items-center font-bold">
                            <Star className="w-3 h-3 mr-1 fill-current" /> High Match
                        </span>
                      )}
                  </div>
                  <p className="text-gray-600 text-sm mt-1">{job.reason}</p>
                  
                  {/* External Link Wrapper */}
                  <a 
                    href={`https://www.google.com/search?q=${encodeURIComponent(job.title + ' jobs near me')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 text-xs text-blue-500 hover:underline mt-2 font-bold"
                  >
                    Search Listings <ExternalLink size={12} />
                  </a>
                </div>

                <div className="flex items-center gap-3">
                    {/* SAVE BUTTON (Stops Propagation to not trigger link) */}
                    <button 
                        onClick={(e) => {
                            e.preventDefault();
                            toggleSavedJob({ id: job.title, ...job }); // Use title as ID for now
                        }}
                        className={`p-2 rounded-full transition-all ${
                            saved ? 'bg-red-50 text-red-500' : 'text-gray-300 hover:text-red-400 hover:bg-gray-50'
                        }`}
                        title={saved ? "Remove from Locker" : "Save to Career Locker"}
                    >
                        <Heart className={`w-5 h-5 ${saved ? 'fill-current' : ''}`} />
                    </button>
                    <ChevronRight className="w-5 h-5 text-gray-300 group-hover:text-blue-500 transition-colors" />
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <p className="text-xs text-gray-500 mt-2 text-center">
        Click the Heart to save to your Dashboard. Click the link to search Google.
      </p>
    </div>
  );
}